exports = module.exports = require("../../../../../../../employee/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".complaint-details-comments-section-comment-and-time-letterSpacing {\n  margin-top: 6px !important; }\n\n.complaint-details-comments-section {\n  margin-top: -11px;\n  background-color: #f7f7f7;\n  -webkit-box-sizing: border-box;\n  /* box-sizing: border-box; */\n  padding: 8px 6px;\n  margin-left: -15px; }\n\n.rainmakcommunicationer-displayInline {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/common/pgr/complaintDetails/components/Comments/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/common/pgr/complaintDetails/components/Comments/index.css
// module chunks = 504